import React, { useState } from "react"
import { Flipper, Flipped } from "react-flip-toolkit"

import './rft.scss';

const listData = [...Array(3).keys()]

// 去除父元素对子元素的影响导致的子元素变形的问题
// 使用亲子过渡
// 告诉 Flipped 组件只在必要的情况下才执行动画
// 通过给 Flipper 传入 decisionData 属性, 通过决策数据决定是否执行动画
// 有时，您会希望Flipper的动画子代根据状态转换的行为有所不同-也许只有某些Flipped元素才能响应特定的变化而制作动画。通过为Flipper组件提供DecisionData属性，您将使该数据可用于每个子Flipped组件的shouldFlip和shouldInvert方法，以便它们可以自行决定是否进行动画处理。
// shouldFlip(previousDecisionData, currentDecisionData) 由Flipper组件传递的当前和先前的DecisionData道具提供的函数。返回一个布尔值，以指示Flipped组件是否应在该特定时刻进行动画处理。
// 使用 stagger 给 Flipped 添加一个交错组， 这样处于同一个组的动画会更自然
// Flipped组件上的onStart回调使我们可以在FLIP动画开始时做一些工作


const ListItem = ({ index, onClick }) => (
  <Flipped 
    flipId={`listItem-${index}`}
    stagger="card"
  >
    <div className="listItem" onClick={() => onClick(index)}>
      <Flipped inverseFlipId={`listItem-${index}`}>
        <div className="listItemContent">
          <Flipped 
            flipId={`avatar-${index}`}
            stagger="card-content"
            shouldFlip={(previousDecisionData, currentDecisionData) => {
              return currentDecisionData === index
            }}
          >
            <div className="avatar" />
          </Flipped>
          <div className="description">
            {listData.map(i => (
              <Flipped
                flipId={`description-${index}-${i}`} 
                stagger="card-content"
                key={i}
                shouldFlip={(previousDecisionData, currentDecisionData) => {
                  return currentDecisionData === index
                }}
              >
                <div />
              </Flipped>
            ))}
          </div>
        </div>
      </Flipped>
    </div>
  </Flipped>
)

const ExpandedListItem = ({ index, onClick }) => (
  <Flipped 
    flipId={`listItem-${index}`}
    stagger="card"
    onStart={el => {
      setTimeout(() => {
        el.classList.add('animated-in');
      }, 600);
    }}
  >
    <div className="expandedListItem" onClick={() => onClick(index)}>
      <Flipped inverseFlipId={`listItem-${index}`}>
        <div className="expandedListItemContent">
          <Flipped 
            flipId={`avatar-${index}`}
            shouldFlip={(previousDecisionData, currentDecisionData) => {
              return currentDecisionData === index
            }}
            stagger="card-content"
          >
            <div className="avatar avatarExpanded" />
          </Flipped>
          <div className="description">
            {listData.map(i => (
              <Flipped 
                flipId={`description-${index}-${i}`} 
                key={i}
                shouldFlip={(previousDecisionData, currentDecisionData) => {
                  return currentDecisionData === index
                }}
                stagger="card-content"
              >
                <div />
              </Flipped>
            ))}
          </div>
          <div className="additional-content">
            {listData.map(i => (
              <div key={i} />
            ))}
          </div>
        </div>
      </Flipped>
    </div>
  </Flipped>
)

const AnimatedList = () => {
  const [focused, setFocused] = useState(null);

  return (
    <div className="list">
      <h1 className="pb-10 text-center text-xl">基于react-flip-toolkit的卡片列表动画</h1>
      <Flipper flipKey={focused} spring="gentle" decisionData={focused}>
        {listData.map(index => {
          return (
            <div key={index}>
              {index === focused ? (
                <ExpandedListItem
                  index={index}
                  onClick={() => setFocused(i => i === index ? null : index)}
                />):(
                <ListItem 
                  index={index} 
                  onClick={() => setFocused(i => i === index ? null : index)} 
                />)
              }
            </div>
          )
        })}
      </Flipper>
    </div>
  )
}

export default AnimatedList;
